import React from 'react';
var SwipeDownIcon = function () {
    return (React.createElement("svg", { width: "24", height: "16", viewBox: "0 0 24 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M22.5 8L12 8L1.5 8", stroke: "#D3D3D3", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default SwipeDownIcon;
